/**
 * The app's tabs on the lib's settings page of an event (slot `context.settings`,
 * lib/js/pages/Context/ContextSettings.vue). The lib brings the members; these are what only this
 * app has. Texts under `tabs.context_settings.<id>`.
 */
import type { ExtensionSlots, SlotContribution } from '@lib/extensions/define';

type EventTab = SlotContribution<ExtensionSlots['context.settings']>;

// Each tab shows to whoever passes the event's read guard: event.read on the event or events.read app wide
const eventTab = {
	contexts: ['event'],
	ability: 'read',
	props: ({ record }) => ({ event: record }),
} satisfies Partial<EventTab>;

export const eventSettingsTabs: EventTab[] = [
	{
		...eventTab,
		id: 'general',
		icon: 'fa-gear',
		group: 'general',
		order: 10,
		component: () => import('./General.vue'),
	},
	{
		...eventTab,
		id: 'timeslot_types',
		icon: 'fa-tags',
		group: 'general',
		order: 20,
		component: () => import('./TimeslotTypes.vue'),
	},
	{
		...eventTab,
		id: 'integrations',
		icon: 'fa-plug',
		group: 'integrations',
		order: 10,
		component: () => import('./Integrations.vue'),
	},
];
